module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-nw.23d1c00b.png";